/**
 * OnboardingLimitModal Component
 * 
 * Modal de bloqueio simplificado para onboarding/tutorial
 * - Exibido quando usuário tenta adicionar mais de 3 membros durante o setup
 * - Sem botão de upgrade (para não tirar do fluxo de tutorial)
 * - Tom amigável e educativo
 * 
 * Fase 5 - UI de Pagamentos
 */

import { AlertTriangle, X } from 'lucide-react';

interface OnboardingLimitModalProps {
  onClose: () => void;
}

export function OnboardingLimitModal({ onClose }: OnboardingLimitModalProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full">
        {/* Header */}
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-1" />
            <div>
              <h3 className="text-xl font-bold">Limite do Plano Gratuito</h3>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Conteúdo */}
        <div className="mb-6">
          <p className="text-gray-700 mb-2">
            Você atingiu o limite do <strong>Plano Gratuito</strong> (até <strong>3 membros</strong>).
          </p>
          <p className="text-gray-700 mb-4">
            Para adicionar mais membros, você poderá assinar o <strong>Plano Básico</strong> ao final do tutorial.
          </p>
          <p className="text-gray-600 text-sm">
            Continue o passo a passo. Ao terminar, mostramos as opções de plano e você decide com calma.
          </p>
        </div>

        {/* Botão único */}
        <button
          onClick={onClose}
          className="w-full py-3 bg-purple-600 text-white rounded-xl font-semibold hover:bg-purple-700 transition-all"
        >
          Entendi
        </button>
      </div>
    </div>
  );
}
